module.exports = __webpack_public_path__ + "img/The-Democratic-Republic-of-the-Congo.0183e9bd.gif";